var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ActionButtons(_a) {
    var onCancel = _a.onCancel;
    return (_jsxs("div", __assign({ className: "flex justify-between max-md:justify-end items-center space-x-4" }, { children: [_jsx("button", __assign({ type: "button", className: "h-12 px-4 rounded-md border border-[#9e2a2b] text-[#9e2a2b] font-bold hover:bg-red-50 transition-colors w-full md:w-auto", onClick: onCancel }, { children: "Cancelar" })), _jsx("button", __assign({ type: "submit", className: "h-12 px-4 rounded-md bg-[#0f4098] text-white font-bold hover:bg-[#0a2e6b] transition-colors w-full md:w-auto shadow-sm" }, { children: "Salvar" }))] })));
}
